import React from 'react';
import { observer } from 'mobx-react';
import { Spring } from 'react-spring';
import BottomScrollListener from 'react-bottom-scroll-listener';

import { url } from 'js/services/Network';
import { blueColor, lightGrey1Color } from 'js/config/style';
import MyItemsPageState from 'js/stores/pages/MyItemsPageState';
import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';

import PageTitle from './PageTitle';
import ItemsList from './ItemsList';
import AddItemButton from './AddItemButton';
import Notice from './Notice';
import Label from './Label';
import {Tooltip} from "reactstrap";

const offset = '1.25rem';

@observer
export default class MyItemsPage extends PageComponent {
  pageName = 'MyItemsPage';
  loginRequired = true;
  pageColor = lightGrey1Color;
  page = MyItemsPageState.create();
  pageWidth = '600px';
  timerId = null;

  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      clicked: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  copyUrl = () => {
    navigator.clipboard.writeText(this.page.micro_store);
    this.setState({clicked: true});

    if(this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  };

  bootstrap = () => this.page.load(true).then(() => {/*analytics.page('My Items Page')*/});

  renderPage() {
    const page = this.page;
    return (
      <AppContent className="my-items-page" padded>
        <Backdrop offset={offset}>
          <Constraint>
            <PageTitle>
              My items
              <button className="btn btn-pod btn-third" title="Copy store link" onClick={this.copyUrl} id="CopyTooltip">
                Share store link
              </button>
              <Tooltip target="CopyTooltip" placement="top" isOpen={this.state.tooltipOpen} toggle={this.toggle}>
                {this.state.clicked ? 'URL copied!' : 'Share store URL'}
              </Tooltip>
            </PageTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          {page.items.length ? (
            <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {animation => <ItemsList style={animation} />}
            </Spring>
          ) : (
            <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {animation => (
                <AddItemButton
                  color="white"
                  textColor={blueColor}
                  style={animation}
                  icon="/images/blue_plus.svg"
                  to={url('create-payment-link-page', { step: null })}>
                  Add an item to sell
                </AddItemButton>
              )}
            </Spring>
          )}

          {page.items.length ? (
            <Notice>
              <Label>Click the '+' to create new payment links to sell your item.</Label>
            </Notice>
          ) : (
            <Notice>
              <Label>Create payment link to sell an item to a buyer.</Label>
            </Notice>
          )}
        </Constraint>

        <BottomScrollListener onBottom={page.loadMore} />
      </AppContent>
    );
  }
}
